export const USER_DATA = 'USER_DATA'
export const MEMBER_LIST = 'member_list'
export const ADDRESS_LIST = 'ADDRESS_LIST'
export const ENROLL_LIST = 'ENROLL_LIST'
export const ORDER_LIST = 'ORDER_LIST'
export const CONSUME_LIST = 'CONSUME_LIST'
export const COUPON_LIST = 'COUPON_LIST'
export const BOOKING_LIST = 'BOOKING_LIST'
export const LOGIN_STATUS = "loginStatus";
